import MuiCardHeader from '@mui/material/CardHeader';
import type { CardHeaderProps as MuiCardHeaderProps } from '@mui/material/CardHeader';

export type CardHeaderProps = MuiCardHeaderProps & object;

/**
 * Props for configuring a card header component from [MicroLibraryCoreUI](https://dev.azure.com/orcha/MicroLibraryTemplate/_git/MicroLibraryCoreUI)
 *
 * @property {CardHeaderProps} props - The props for the card header.
 */

export const CardHeader = ({ ...props }: CardHeaderProps) => {
  return (
    <MuiCardHeader
      variant="body1"
      titleTypographyProps={{
        sx: {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          maxWidth: '170px',
          wordWrap: 'break-word',
          fontSize: '14px',
          fontWeight: 700,
          marginRight: '5px',
        },
        'data-testid': 'app-card-title',
      }}
      sx={{
        padding: '0 16px',
        height: '80px',
        '& .MuiCardHeader-action': {
          marginTop: '16px',
        },
      }}
      {...props}
    />
  );
};
